import { useSystemLanguage } from '@contexts/SystemLanguageContext';
import { getAntdLocale } from '@contexts/utils';
import type { Antd6Mode, Antd6VariantName } from '@theme/antd6Theme';
import { resolveAntd6Theme } from '@theme/antd6Theme';
import { ConfigProvider } from 'antd-v6';
import type { ConfigProviderProps } from 'antd-v6/es/config-provider';

interface Antd6ProviderProps extends Readonly<Omit<ConfigProviderProps, 'theme'>> {
  readonly mode?: Antd6Mode;
  /** Named slices from `antd6Variants`; add one there instead of passing an ad-hoc theme. */
  readonly themeVariant?: Antd6VariantName | readonly Antd6VariantName[];
}

const NO_VARIANTS: readonly Antd6VariantName[] = [];

export function Antd6Provider({
  children,
  mode = 'dark',
  themeVariant,
  locale,
  ...props
}: Readonly<Antd6ProviderProps>) {
  const [systemLanguage] = useSystemLanguage();
  const variants = typeof themeVariant === 'string' ? [themeVariant] : themeVariant ?? NO_VARIANTS;

  return (
    <ConfigProvider
      prefixCls="antd6"
      wave={{ disabled: true }}
      theme={resolveAntd6Theme(mode, variants)}
      locale={locale ?? getAntdLocale(systemLanguage)}
      {...props}
    >
      {children}
    </ConfigProvider>
  );
}
